import { render } from "./OperatingAgreement.vue?vue&type=template&id=f2510538&scoped=true"
import script from "./OperatingAgreement.vue?vue&type=script&lang=js"
export * from "./OperatingAgreement.vue?vue&type=script&lang=js"

import "./OperatingAgreement.vue?vue&type=style&index=0&id=f2510538&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2510538"]])

export default __exports__